<template>
  <div>
    <CJumbotron class="custom-jumbotron" :style="{ backgroundImage: `url(${backgroundBannerUrl})` }">
      <CContainer>
        <CRow>
          <CCol sm="12" lg="12" class="element-50 mt-5 text-center">
            <div><img style="max-width:100%" class="text-center" src="../assets/img/textPro.png" /></div>
            <div><span style="color:#fff; position: relative;width: 100%; display: flex;background-size: cover;background: rgba(24, 24, 24, 0.3);" class="display-title-banner mt-2 custom-shadow" data-aos="fade-up">
              Are you a Pro ? You will not be a Pro until you teach in our
              ProClass
            </span></div>
            <CButton color="primary" class="mt-5" size="lg" style="width:200px;height:70px">LET ME IN</CButton>
            <br /><br />
              <br /><br />
          </CCol>
        </CRow>
      </CContainer>
    </CJumbotron>
    <CCol sm="12" lg="12" class="mt-2">
      <CRow>
        <CCol
          sm="6"
          lg="6"
          style="background-size: cover; color: #fff"
          :style="{ backgroundImage: `url(${backgroundUrl})` }"
        >
        </CCol>
        <CCol sm="6" lg="6">
          <h1 class="custom-pro-title mt-5 ml-5" data-aos="fade-up">About ProClass</h1>

          <h3 class="display-5-custom mt-5 ml-5 mr-5" data-aos="fade-up">
            ProClass is a place where all experts and professionals gather and
            impart their knowledge to juniors. Join, teach and eventually raise
            as much money as possible while growing your network.
          </h3>

           <CButton color="primary" class="mt-5 mb-5 ml-5" size="lg" style="width:200px;height:70px">READ MORE</CButton>
        </CCol>
      </CRow>
    </CCol>
    <CCol style="background-color: rgb(246, 246, 246)" sm="12" lg="12">
      <br />
       <h1 class="custom-pro-title mt-5 ml-5" data-aos="fade-up">You will enjoy</h1>
      <h3 class="display-5 mt-2 ml-5 mr-5 mb-5" data-aos="fade-up">Show your skill to others and earn more ...</h3>
      <CRow class="m-2">
        <CCol sm="4" lg="4" class="text-center p-0">
          <CCard class="custom-card">
            <div class="text-center p-3">
              <img
                style="max-width: 100%; width: 170px"
                class="m-0 text-center"
                src="../assets/img/helping.png"
                 data-aos="fade-up"
              />
            </div>
             <h2 class="custom-pro-subtitle mt-2" data-aos="fade-up">Helping Others</h2>
          </CCard>
        </CCol>
        <CCol sm="4" lg="4" class="text-center p-0">
          <CCard class="custom-card">
            <div class="text-center p-3">
              <img
                style="max-width: 100%; width: 200px"
                class="m-0"
                src="../assets/img/grow.png"
                 data-aos="fade-up"
              />
            </div>
            <h2 class="custom-pro-subtitle mt-2" data-aos="fade-up">Grow Networking</h2>
          </CCard>
        </CCol>
        <CCol sm="4" lg="4" class="text-center p-0">
          <CCard class="custom-card">
            <div class="text-center p-3">
              <img
                style="max-width: 100%; width: 200px"
                class="m-0"
                src="../assets/img/earn.png"
                 data-aos="fade-up"
              />
            </div>
            <h2 class="custom-pro-subtitle mt-2" data-aos="fade-up">Earn More Money</h2>
          </CCard>
        </CCol>
      </CRow>
        <br />
    </CCol>
    <CCol style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
       <h1 class="custom-pro-title mt-5 ml-5" data-aos="fade-up">Best ProClass tutors</h1>
     <h3 class="display-5 mt-2 ml-5 mr-5 mb-5" data-aos="fade-up">
        These are some of our best Pros who can teach with their secrets. Join
        them today!
      </h3>

      <CRow>
        <CCol sm="4" lg="4" class="p-0">
          <img style="max-width: 100%" src="../assets/img/ameen.jpg" data-aos="fade-up"/>
          <div class="bottom-left-name">
            <h3 class="ml-2 mr-2" data-aos="fade-up">Dr. AMEEN</h3>
          </div>
          <div class="bottom-left">
            <h1 class="ml-2 mr-2" data-aos="fade-up">Machine Learning</h1>
          </div>
        </CCol>
        <CCol sm="4" lg="4" class="p-0">
          <img style="max-width: 100%" src="../assets/img/scientist.jpg" data-aos="fade-up"/>
          <div class="bottom-left-name">
            <h3 class="ml-2 mr-2" data-aos="fade-up">Dr. AAINAA</h3>
          </div>
          <div class="bottom-left">
            <h1 class="ml-2 mr-2" data-aos="fade-up">GEO Scientist</h1>
          </div>
        </CCol>
        <CCol sm="4" lg="4" class="p-0">
          <img style="max-width: 100%" src="../assets/img/afiq.jpg"  data-aos="fade-up"/>
          <div class="bottom-left-name">
            <h3 class="ml-2 mr-2" data-aos="fade-up">Dr. AFIQ</h3>
          </div>
          <div class="bottom-left">
            <h1 class="ml-2 mr-2" data-aos="fade-up">Stock Remisier</h1>
          </div>
        </CCol>
      </CRow>
    </CCol>
    <CCol style="background-color: rgb(246, 246, 246)" sm="12" lg="12">
      <br />
      <h1 class="custom-pro-title mt-5 ml-5 mb-5" data-aos="zoom-in-up">Our Platform Support</h1>
      <CRow class="m-2">
        <CCol sm="4" lg="4">
          <CCard>
            <div class="text-center p-3">
              <img
                style="max-width: 100%"
                class="m-0 text-center"
                src="../assets/img/market.jpg"
                data-aos="zoom-in-up"
              />
            </div>
            <h2 style="color:rgb(75, 57, 181)" class="mt-2 ml-3" data-aos="zoom-in-up">Market yourself</h2>
            <h5 class="p-3 display-6" data-aos="zoom-in-up">
              You can market your skills on our platform to earn more money
            </h5>
          </CCard>
        </CCol>
        <CCol sm="4" lg="4">
          <CCard>
            <div class="text-center p-3">
              <img
                style="max-width: 100%"
                class="m-0"
                src="../assets/img/latest.jpg"
                data-aos="zoom-in-up"
              />
            </div>
             <h2 style="color:rgb(75, 57, 181)" class="mt-2 ml-3" data-aos="zoom-in-up">Latest technology</h2>
             <h5 class="p-3 display-6" data-aos="zoom-in-up">
              The technology we build will help you in all matters to get more
              students and create your network and also raise money
            </h5>
          </CCard>
        </CCol>
        <CCol sm="4" lg="4">
          <CCard>
            <div class="text-center p-3">
              <img
                style="max-width: 100%"
                class="m-0"
                src="../assets/img/informed.jpg"
                data-aos="zoom-in-up"
              />
            </div>
             <h2 style="color:rgb(75, 57, 181)" class="mt-2 ml-3" data-aos="zoom-in-up">Always be informed</h2>
            <h5 class="p-3 display-6" data-aos="zoom-in-up">
              Information is always sent directly to your hands. you will not
              miss every opportunity. quests from the juniors racing to hear you
              teach them
            </h5>
          </CCard>
        </CCol>
      </CRow>
    </CCol>

    <CCol :style="{ backgroundImage: `url(${backgroundBannerReg})` }"  class="custom-bg" sm="12" lg="12">
      <CRow class="ml-5">
        <CCol sm="4" lg="4" class="mt-5">
          <br /><br />
          <h1 class="display-title mt-5 mb-5">Register</h1>

          <CInput class="text" placeholder="Name" size="lg" />
          <CInput class="text" placeholder="Email" size="lg" />
          <CInput class="text" placeholder="Phone" size="lg" />

          <CButton color="primary" class="mt-5 mb-5" size="lg"
            >Register</CButton
          >
        </CCol>
        <CCol sm="8" lg="8">
          <img style="max-width: 100%;float:right" src="../assets/img/bgregister.png" />
        </CCol>
      </CRow>
    </CCol>

    <CCol :style="{ backgroundImage: `url(${backgroundBannerReg})` }" sm="12" lg="12">
      <CRow>
        <CCol sm="12" lg="12">
          <div class="text-center">
          <img style="max-width: 100%" src="../assets/img/bgPros.png" />
          </div>
        </CCol>
      </CRow>
    </CCol>


    <CCol  style="bacground-color: rgb(240, 240, 240)" sm="12" lg="12">
     
        <CCol sm="12" lg="12">
           <CRow>

          <CCol sm="3" lg="3">
              <h1 class="custom-pro-title mt-3 ml-5" data-aos="fade-up">Our Platform Support</h1>
             <h5 class="ml-5">How to get in touch with us.</h5>
          </CCol>
            <CCol sm="3" lg="3">
                <h5 class="mt-5 custom-pro-title">PHONE NUMBER</h5>
                <h3 class="display-6">(6019) 3857722</h3>
            </CCol>
              <CCol sm="3" lg="3">
                 <h5 class="mt-5 custom-pro-title">EMAIL ADDRESS</h5>
                <h3 class="display-6">Info@pickiddo.com</h3>
              </CCol>
                <CCol sm="3" lg="3">
                   <h5 class="mt-5 custom-pro-title">MAILING ADDRESS</h5>
                <h3 class="display-6">The Square@One City, T1-14-13,Jalan USJ25/1C,47650 UEP Subang Jaya, Selangor Darul Ehsan, Malaysia</h3>
                </CCol>
           </CRow>
        </CCol>     
     
    </CCol>
  </div>
</template>

<script>


import backgroundUrl from "../assets/img/s3.jpg";
import backgroundUrlPro from "../assets/img/bgPros.png";
import backgroundBannerUrl from "../assets/img/bgProClass.jpg";
import backgroundBannerReg from "../assets/img/bgReg.jpg";
import AOS from "aos";
import "aos/dist/aos.css";


export default {
  name: "ProClass",
  data() {
    return {
      backgroundUrl,
      backgroundUrlPro,
      backgroundBannerUrl,
      backgroundBannerReg
    };
  },
   created() {
    AOS.init();
  },
};
</script>
